<template lang="html">
  <div class="menuItem">
    <mobile-menu-section-header
      v-if="hasHeader"
      :label="headerLabel"
      :labelId="headerLabelId">
    </mobile-menu-section-header>
    <slot></slot>
  </div>
</template>

<script>
import MobileMenuSectionHeader from '@/components/menus/MobileMenuComponents/MobileMenuSectionHeader'

export default {
  name: 'MobileMenuSection',
  props: [
    /** Label to display for the section header */
    'headerLabel',
    /** i18n label ID used to display the section header */
    'headerLabelId'
  ],
  components: {
    'mobile-menu-section-header': MobileMenuSectionHeader
  },
  computed: {
    /**
    * Returns true if a headerLabel or headerLabelId value was given by the parent component
    * Used to determine if a header should be rendered or not
    */
    hasHeader () {
      return (this.headerLabel || this.headerLabelId)
    }
  }
}
</script>

<style lang="css" scoped>
.menuItem {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// MobileMenuSection.vue?72e9eb76